import { useMutation } from "@tanstack/react-query";
import addFollowupDateToApt from "../../controllers/appointments/alter-followup-date";

const usePostAddAppointmentFollowupDate = () => {
  return useMutation(addFollowupDateToApt, {});
};

export default usePostAddAppointmentFollowupDate;
